<template>
	<div class="body" v-if="loading">
		<div class="body-left">
			<div class="left-head">
				发布人信息
			</div>
			<div class="left-body" v-if="!proDetail.user_record.phone">
				<div class="body-item" v-if="proDetail.user_info">
					<div class="item-title">
						{{proDetail.user_info.nickname}}
					</div>
					<div class="item-content" >
						联系方式:{{proDetail.user_info.mobile || proDetail.user_info.email }}
					</div>
				</div>
				<div class="body-item">
					<div class="item-title">
						<!-- {{proDetail.user_record.company}} -->
					</div>
					<!-- <div class="item-content">
						清华大学 <span style="color: #0052D9;margin-left: 5px;cursor:pointer;"
							@click="$router.push(`/geniusClub/companyInfo?id=${1}`)">(已认证)</span>
					</div> -->
					<!-- <div class="item-content">
						北京科技 <span style="margin-left: 5px;">(未认证)</span>
					</div> -->
				</div>
				<div class="body-item">
					<div class="item-title">
						公司评价
					</div>
					<div class="item-content">
						暂无
					</div>
				</div>
				<!-- 	<div class="guanzhu">
					关注公司
				</div> -->
			</div>
			<div class="left-body" v-else>
				<div class="body-item">
					<div class="item-title">
						{{proDetail.user_record.name}}
					</div>
					<div class="item-content" v-if="(bindInfo.bid_info && bindInfo.bid_info.check_status == 1) || isf==1">
						联系方式:{{proDetail.user_record.phone}}
					</div>
				</div>
				<div class="body-item">
					<div class="item-title">
						{{proDetail.user_record.company}}
					</div>
					<!-- <div class="item-content">
						清华大学 <span style="color: #0052D9;margin-left: 5px;cursor:pointer;"
							@click="$router.push(`/geniusClub/companyInfo?id=${1}`)">(已认证)</span>
					</div> -->
					<!-- <div class="item-content">
						北京科技 <span style="margin-left: 5px;">(未认证)</span>
					</div> -->
				</div>
				<div class="body-item">
					<div class="item-title">
						公司评价
					</div>
					<div class="item-content">
						暂无
					</div>
				</div>
				<!-- 	<div class="guanzhu">
					关注公司
				</div> -->
			</div>
		</div>
		<div class="body-main">
			<div class="main-head">
				<div class="head-left">
					<img :src='getImgSrc(proDetail.image)' style="width: 238px;height: 238px;" alt="">
				</div>
				<div class="head-right">
					<div class="title">
						{{proDetail.title}}
					</div>
					<div class="introduce">
						<div>科学类别：{{proDetail.subjectcate_name}}</div>
						<div>行业类别：{{proDetail.industry_name}}</div>
						<div>更新时间：{{timeConversion(proDetail.updatetime)}}</div>
					</div>
					<div class="content">
						<p v-html="proDetail.summary_info"></p>
					</div>
					<div class="bottom">
						<span style="color: #0052D9;"><i class="el-icon-view"
								style="font-size: 20px;"></i>{{proDetail.hits}}</span>
						<span style="margin-left: 20px;cursor: pointer;" @click="handleLike"
							:style="proDetail.collect == 1 ?'color: #0052D9;':''"><i class="el-icon-star-on"
								style="font-size:20px;"></i>{{proDetail.collect_num}}</span>
					</div>
				</div>
			</div>
			<div class="main-body">
				<div class="body-item">
					<div style="background:#E5EDFB;">
						<div
							style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
							基本信息
						</div>
					</div>
					<div v-if="bindInfo.bid_info">
						<div style="height: 100px;text-align: center;font-size: 20px;line-height: 100px;">
							<div v-if="proDetail.status >= 5">
								已归档
							
							</div>
							<div v-if="bindInfo.bid_info.check_status == 1">
								您的方案 <span style="text-decoration: underline;cursor: pointer;"
									@click="$router.push(`/solutionDetail/?id=${bindInfo.scheme_info.id}`)">
									"{{bindInfo.scheme_info.title}}" </span> 已中标

							</div>
							
							<div v-if="bindInfo.bid_info.check_status == 2">
								被淘汰

							</div>
							
							<div v-else>
								待处理
							</div>
						</div>
					</div>
					<div v-else>

						<div class="body-item-title">
							<span>创建解决方案</span>
							<div @click="submitToA">提交方案给甲方</div>
						</div>
						<div class="item-detail">
							<div class="table" v-if="solutionList.total">
								<el-radio-group v-model="result" style="width: 100%;">
									<div class="table-line" v-for="(item,index) in solutionList.data"
										:style="index%2==0?'background: #FAFAFA;':''">
										<div class="line-check">
											<el-radio type="checkbox" :label="item.id">{{''}}</el-radio>
										</div>
										<div class="line-id">
											{{index+1}}
										</div>
										<div class="fangan">
											{{item.title}}
										</div>
										<div class="line-select">
											<el-select v-model="item.value" value-key="id" @change="$forceUpdate()"
												placeholder="选择承担此项目所依靠的公司">
												<el-option v-for="data in item.company" :key="data.id"
													:label="data.name" :value="data.id">
												</el-option>
											</el-select>
										</div>
										<div class="deal">
											<!-- //<p style="color: red;font-size: 14px;">(个人公司竞争力弱，建议加入头部公司)</p> -->
										</div>

									</div>
								</el-radio-group>
							</div>
							<div v-else
								style="color: #999;text-align: center;display: flex;align-items: center;justify-content: center;">
								<p>暂无解决方案</p>
							</div>

						</div>
						<div class="body-mid-footer">
							<img src='../../assets/images/circleP.png'
								@click='$router.push(`/solutionDetail/releaseSolution?type=wyyy&t=`+(proDetail.title))' style="width: 23px;
						height: 23px;" alt="">
						</div>
					</div>

				</div>

				<div  v-if="bindInfo.bid_info && bindInfo.bid_info.check_status == 1" class="body-item">
					<div   class="body-item-title">
						<span>进度更新</span>

					</div>
				</div>
				<div   v-if="bindInfo.bid_info && bindInfo.bid_info.check_status == 1"  class="item-detail">
					<div class="table">
						<div class="table-line" v-for="(item,index) in updateList"
							:style="index%2==0?'background: #FAFAFA;':''">
							<div class="line-icon">
								<img src="../../assets/images/biaodui.png" alt="">
							</div>

							<div class="line-status">
								{{item.name}}
							</div>
							<div class="starScore">

								<el-rate allow-half v-model="item.score" disabled></el-rate>
							</div>

							<div class="jindu">
								{{ item.plan_date }}
							</div>

						</div>
						<div v-if="bindInfo.bid_info" class="table-line"
							style="background: #FAFAFA;text-align: center;justify-content: center;">
							项目金额:{{bindInfo.bid_info.price}}
						</div>
						<div v-else class="table-line"
							style="background: #FAFAFA;text-align: center;justify-content: center;">
							项目金额:{{proDetail.price}}
						</div>

					</div>
				</div>
				<div class="body-item">
					<div  v-if="bindInfo.bid_info"  class="body-item-title">
						<span>双方互评</span>

					</div>
				</div>
				<div style="padding: 10px 15px"  v-if="bindInfo.bid_info && bindInfo.bid_info.check_status == 1">
					<div class="table" >
						<div class="table-line" v-if="bindInfo.bid_info.bid_acquire_remark" style="display: flex;">

							<div class="jindu" style="flex: 1;">
								甲方评价：{{bindInfo.bid_info.bid_acquire_remark}}
							</div>
							<div class="starScore">
								<el-rate allow-half v-model="bindInfo.bid_info.bid_acquire_score * 1"
									disabled></el-rate>
							</div>
						</div>
						<div class="table-line" v-if="bindInfo.bid_info.owner_acquire_remark" style="display: flex;">

							<div class="jindu" style="flex: 1;">
								乙方评价：{{bindInfo.bid_info.owner_acquire_remark}}
							</div>
							<div class="starScore">
								<el-rate allow-half v-model="bindInfo.bid_info.owner_acquire_score * 1"
									disabled></el-rate>
							</div>
						</div>
					</div>
				</div>
				<div class="item-detail"  v-if="bindInfo.bid_info && bindInfo.bid_info.check_status == 1">
					<p style="display: flex;">评分： <el-rate allow-half v-model="starScore"></el-rate></p>
					<el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="PJarea">
					</el-input>
					<div style="display: flex;justify-content: flex-end;cursor: pointer;">
						<div class="pinglBtn" @click="projectAcommentB">发表评论</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				shoucang: false,
				checkList: [],
				result: [],
				starScore: 0,
				PJarea: '',
				proDetail: '',
				table: [],
				companyValue: [],
				solutionList: [],
				companyList: [],
				loading: false,
				updateList: [],
				bindInfo: '',
				isf:0,
				user_id:'',
			}
		},
		async created() {  
		    await this.getCompanyList();  
		    // 先获取详情，确保 user_id 被设置  
		    await this.getDetail(this.$route.query.id);  
		    // 现在可以安全地调用 isfun，因为 user_id 已经被赋值  
		    this.loading = true; // 注意：通常应该在数据加载完成后设置 loading 为 true，但在这里为了保持原样，我将其放在了这里  
		    this.getMySolution();  
		    this.getUpdateList(); // 注意：这个调用在 getDetail 中也被调用了，可能存在重复调用的问题  
		    this.isfun(); // 现在这里可以安全地调用 isfun  
		    // this.loading = false; // 通常应该在所有数据加载完成后设置 loading 为 false  
		  },  
		methods: {
			
			async projeckGetbindInfo() {
				const info = await this.$api.projeckyfGetbindInfo({
					projectneed_id: this.proDetail.id
				})
				this.bindInfo = info.data
			},
			async projectAcommentB() {
				const comment = await this.$api.projectBcommentA({
					owner_acquire_remark: this.PJarea,
					owner_acquire_score: this.starScore,
					projectneed_id: this.proDetail.id
				})
				if (comment.code == 1) {
					this.$message({
						message: comment.msg,
						type: 'success'
					})
					this.projeckGetbindInfo()
					this.starScore = ''
					this.PJarea = ''
				} else {
					this.$message({
						message: comment.msg,
						type: 'error'
					})
				}
				console.log(comment);
			},
			async submitToA() {
				const obj = this.solutionList.data.find(item => item.id == this.result)
				if (obj == undefined) {
					this.$message({
						message: '请选择提交方案',
						type: 'error'
					})
					return
				} else {
					const sub = await this.$api.submmitToPartyA({
						projectneed_id: this.$route.query.id,
						company_id: obj.value,
						scheme_id: obj.id
					})
					if (sub.code == 1) {
						this.$message({
							message: sub.msg,
							type: 'success'
						})
						window.location.reload();
					} else {
						this.$message({
							message: sub.msg,
							type: 'warning'
						})
					}
				}
			},
			async getCompanyList() {
				const list = await this.$api.getMyCompanyList({
					page_size: 9999
				})
				this.companyList = list.data.data
				console.log(list);
			},
			async getDetail(id) {  
			      const detail = await this.$api.projectneedGetDetail({ id: id });  
			      this.proDetail = detail.data;  
			      this.user_id = detail.data.user_id;  
			      console.log('获取到的项目数据user_id', this.user_id);  
			      this.projeckGetbindInfo();  
			      // 注意：通常不建议在这里再次调用 getUpdateList()，因为它可能会导致不必要的重复调用  
			      // this.getUpdateList(); // 移除这行或确保它不会被重复调用  
			    },  
			    async isfun() {  
			      console.log('发布人ID666666', this.user_id);  
			      if (!this.user_id) {  
			        console.error('user_id 未定义，无法检查好友关系');  
			        return;  
			      }  
			      const isfvalue = await this.$api.isfriendis({ projectneeduserid: this.user_id });  
			      console.log('判断是否为好友', isfvalue.data);  
			      if (isfvalue.data === 1) {  
			        this.isf = 1; // 注意：这里应该直接赋值为 1 而不是 isfvalue.data，因为您已经检查了它的值  
			      } else {  
			        this.isf = 0; // 或者您可以设置一个默认值来表示不是好友  
			      }  
			    },  
			async getMySolution() {  
			  // 假设这是从服务器获取的数据  
			  const solution = await this.$api.getMyRelesedSolution({  
			    cate: 1,  
			    page_size: 9999  
			  });  
			  
			  // if (!this.companyList || this.companyList.length === 0) {  
			  //   console.error('companyList is not loaded or empty!');  
			  //   return;  
			  // }  
			  
			  // 设置 solutionList  
			  this.solutionList = {  
			    total: solution.data.total, // 注意：这里假设 total 是在 data 对象的顶层，根据实际情况调整  
			    data: solution.data.data.map((item) => {  
			      // 假设每个 item 都应该使用完整的 companyList  
			      item.company = this.companyList;  
			      // 设置默认值为 companyList 中的第一条数据的 id  
			      item.value = this.companyList.length > 0 ? this.companyList[0].id : null;  
			      return item;  
			    })  
			  };  
			  
			  console.log(this.solutionList); // 打印修改后的 solutionList  
			},
			async getUpdateList() {
				const list = await this.$api.getProjectUpdateList({
					projectneed_id: this.proDetail.id
				})
				list.data.forEach(item => {
					if (item.score) {
						item.score = parseFloat(item.score)
					}
				})
				this.updateList = list.data
			},
			handleLike() {
				if (this.canLike) {
					this.canLike = false;
					this.collectHandler();
					setTimeout(() => {
						this.canLike = true;
					}, 1000);
				}
			},
			async collectHandler(id) {
				if (this.proDetail.collect) {
					const collect = await this.$api.productCancelCollect({
						id: this.proDetail.id
					})
					if (collect.code == 1) {
						this.$message({
							message: '取消收藏',
							type: 'warning',
							center: true
						})
						this.proDetail.collect = 0
						this.proDetail.collect_num -= 1
					}
				} else {
					const collect = await this.$api.productCollect({
						id: this.proDetail.id
					})
					if (collect.code == 1) {
						this.$message({
							message: '收藏成功',
							type: 'success',
							center: true
						})
						this.proDetail.collect = 1
						this.proDetail.collect_num += 1
					}
				}
			},
		}
	}
</script>
<style>
	/* .el-radio__label {
		color: black;
	}
	
	.radio {
		position: relative;
		display: inline-block;
		margin-right: 12px;
	}
	
	.radio input {
		width: 18px;
		height: 18px;
		appearance: none;
		-webkit-appearance: none;
		opacity: 0;
		outline: none;
	}
	
	
	
	.el-radio__inner {
		border-radius: 0;
	}
	.el-radio__label{
		display: none;
	}
	.el-radio__inner::after {
		content: "";
		position: absolute;
		text-align: center;
		border-radius: 0;
		width: 14px;
		height: 14px;
		content: "✓";
		color: #fff;
		font-weight: bold;
		background-color: #0052D9;
	} */

	input[type=checkbox] {
		cursor: pointer;
		position: relative;
		width: 25px;
		height: 24px;
		font-size: 16px;
	}

	input[type=checkbox]::after {
		position: absolute;
		top: 0;
		color: #000;
		width: 25px;
		height: 24px;
		display: inline-block;
		visibility: visible;
		padding-left: 0px;
		text-align: center;
		content: ' ';
		border-radius: 3px
	}

	input[type=checkbox]:checked::after {
		content: "✓";
		color: #fff;
		font-size: 16px;
		font-weight: bold;
		background-color: #0052D9;
	}

	.el-rate {
		height: 30px;
	}

	.el-icon-star-on:before {
		font-size: 24px;
	}

	.el-icon-star-off:before {
		font-size: 24px;
	}

	.el-rate__icon {
		font-size: 24px;
	}

	.el-icon-arrow-up:before {
		color: black;
	}
</style>
<style scoped lang="less">
	/deep/.el-input__inner::placeholder {
		color: black;
	}

	/deep/.el-input__inner {
		border: none;
		color: black;
		background: none;
		width: 250px;
	}

	.body-mid-footer {
		display: flex;
		padding: 20px;
		box-sizing: border-box;
		height: 50px;
		background: #F6F6F6;
		justify-content: center;
		font-size: 18px;
		cursor: pointer;
		align-items: center;
		width: 1065px;
		margin: 10px auto;
		margin-bottom: 40px;

		&>img {
			margin-left: 20px;
			width: 16px;
			height: 16px;
		}
	}

	.pinglBtn {
		width: 132px;
		height: 38px;
		background: #0052D9;
		border: 1px solid #E5E5E5;
		margin-top: 20px;
		color: white;
		line-height: 38px;
		text-align: center;
	}

	.table {
		border: 1px solid #EEEEEE;
		text-align: center;

		.table-line {
			width: 100%;

			.jindu {
				width: 130px;
			}

			.line-status {
				width: 120px;
				border: 1px solid #EEEEEE;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.starScore {
				color: #FFB821;
				width: 190px;
				border: 1px solid #EEEEEE;
				display: flex;
				height: 100%;
				align-items: center;
				justify-content: center;
			}

			.zhuanjia {
				display: flex;
				flex: 1;
				justify-content: flex-end;

				div {
					margin-right: 20px;
					width: 132px;
					color: #0052D9;
					height: 34px;
					border: 1px solid #0052D9;
					line-height: 34px;
					cursor: pointer;
				}

				&>div:last-child {
					background: #0052D9;
					color: white;
				}
			}

			.line-icon {
				width: 75px;
				display: flex;
				justify-content: center;
				border: 1px solid #EEEEEE;
				height: 100%;
				align-items: center;

				img {
					width: 23px;
					height: 23px;
				}
			}

			.line-select {
				width: 300px;
			}

			.line-id {
				font-size: 18px;
				width: 75px;
			}

			.fangan {
				width: 220px;
			}

			.nickName {
				width: 200px;
			}

			.company {
				width: 250px;
			}

			.deal {
				width: 280px;
				flex: 1;

			}

			.score {
				width: 120px;
			}

			align-items: center;
			display: flex;
			font-size: 16px;
			border-bottom: 1px solid #EEEEEE;
			height: 55px;

			.line-check {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 50px;
				border: 1px solid #EEEEEE;
				height: 100%;
			}
		}

		.darkbg {
			background: #FAFAFA;
		}
	}

	.body {
		display: flex;
		padding-bottom: 40px;
		justify-content: space-between;

		.body-main {
			.main-body {
				.body-item-title {
					display: flex;
					justify-content: space-between;
					font-size: 18px;
					padding: 20px;
					align-items: center;

					&>div {
						cursor: pointer;
						width: 140px;
						line-height: 40px;
						text-align: center;
						height: 40px;
						background: #F6F6F6;
						border: 1px solid #D2D2D2;
					}
				}

				.item-detail {
					.detail-line {
						display: flex;
						margin: 10px;

						p {
							width: 350px;
							overflow: hidden;
							text-overflow: ellipsis;
						}

						a {}
					}

					padding:10px 15px;
				}

				margin-top: 20px;
				background: white;
				padding: 20px 0;
			}

			.main-head {
				.bottom {
					display: flex;

					span {
						font-size: 16px;
						display: flex;
						align-items: center;
					}

					margin-top: 25px;
				}

				.content {
					height: 100px;
					font-size: 16px;
					color: #222222;
					line-height: 26px;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.introduce {
					margin: 16px 0;
					display: flex;
					font-size: 14px;
					color: #888888;

					&>div {
						width: 33%;
					}
				}

				.head-right {
					flex: 1;
					padding: 8px 15px;
					box-sizing: border-box;

					.title {
						font-size: 20px;
						font-weight: bold;
					}
				}

				display: flex;
				padding: 19px;
				box-sizing: border-box;
				height: 277px;
				background: #FFFFFF;
			}

			width:1100px;

		}
	}

	.body-left {
		.left-body {
			.guanzhu {
				width: 230px;
				height: 46px;
				background: #0052D9;
				line-height: 46px;
				color: white;
				text-align: center;
				cursor: pointer;
			}

			.body-item {
				margin: 10px 0;
				margin-bottom: 30px;

			}

			.item-title {
				font-size: 18px;
				margin-bottom: 10px;
			}

			.item-content {
				margin: 5px 0;
				color: #888888;
			}

			padding: 10px 15px;
			box-sizing: border-box;
		}

		.left-head {
			font-size: 20px;
			line-height: 69px;
			padding-left: 15px;
			box-sizing: border-box;
			font-weight: bold;
			width: 260px;
			height: 69px;
			color: #0052D9;
			background: #E5EDFB;
		}

		width: 260px;
		height:330px;
		background: #FFFFFF;
	}
</style>